import { render, staticRenderFns } from "./loginC.vue?vue&type=template&id=2137a59b&scoped=true"
import script from "./loginC.vue?vue&type=script&lang=js"
export * from "./loginC.vue?vue&type=script&lang=js"
import style0 from "./loginC.vue?vue&type=style&index=0&id=2137a59b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2137a59b",
  null
  
)

export default component.exports